module.exports = __webpack_public_path__ + "img/qingdan.3eaeb28a.png";